module.exports = __webpack_public_path__ + "img/logo-bis.867b4008.png";